var React = require('react');

function Loader1 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1_328)","key":0},React.createElement("rect",{"width":"90","height":"110","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1_328"},React.createElement("rect",{"width":"90","height":"110","fill":"white"})))]);
}

Loader1.defaultProps = {"width":"90","height":"110","viewBox":"0 0 90 110","fill":"none"};

module.exports = Loader1;

Loader1.default = Loader1;
